import React from 'react';
import PackageSearchListItem from './PackageSearchListItem';

const PackageListGrid = (props) => {
    return (
        <div className="house-land-list">
            {props.data.map((thisPackage) =>
                <PackageSearchListItem key={thisPackage.id} data={thisPackage} />
            )}
        </div>


    );
};

export default PackageListGrid;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/elements/PackageSearchList.js
 **/